import { render, staticRenderFns } from "./DocumentConf.vue?vue&type=template&id=4d324a4a"
import script from "./DocumentConf.vue?vue&type=script&lang=js"
export * from "./DocumentConf.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports